import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './shared/material.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CoreModule } from './core/core.module';
import { QuickSearchModule } from './quick-search/quick-search.module';
import { SharedModule } from './shared/shared.module';
import { LaunchComponent } from './launch.component';
import { AdjustmentsModule } from './quick-search/adjustments/adjustments.module';
import { UnderDevelopmentNoticeComponent } from './shared/display/under-development-notice/under-development-notice.component';
import { PrimaryInterceptor } from './core/interceptors/primary.interceptor';
import { DialogSearchingComponent } from './core/dialog/dialog-searching/dialog-searching.component';
import { NavSidebarComponent } from './core/nav-sidebar/nav-sidebar.component';
import { AppGeneralStateService } from './app-general-state.service';
import { HomeComponent } from './feature/home/home.component';
import { MatButtonModule } from '@angular/material/button';
import { FindInvoiceComponent } from './feature/dashboard/dashboard-components/find-invoice/find-invoice.component';
import { InvoiceAgingComponent } from './feature/dashboard/dashboard-components/invoice-aging/invoice-aging.component';
import { SearchSnacksHomeComponent } from './feature/search-snacks-home/search-snacks-home.component';
import { FindByInvoiceNumberComponent } from './feature/search-snacks-home/find-by-invoice-number/find-by-invoice-number.component';
import { InvoiceAgingChartComponent } from './feature/dashboard-components/invoice-aging-chart/invoice-aging-chart.component';
import { InvoiceAgingTestComponent } from './feature/dashboard-components/invoice-aging-test/invoice-aging-test.component';
import { DialogSpaceCompanyConfirmationComponent } from './core/dialog/dialog-space-company-confirmation/dialog-space-company-confirmation.component';

@NgModule({
  declarations: [
    AppComponent,
    LaunchComponent,
    UnderDevelopmentNoticeComponent,
    DialogSearchingComponent,
    HomeComponent,
    FindInvoiceComponent,
    InvoiceAgingComponent,
    SearchSnacksHomeComponent,
    FindByInvoiceNumberComponent,
    InvoiceAgingChartComponent,
    InvoiceAgingTestComponent,
    DialogSpaceCompanyConfirmationComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    // HttpClientModule, //20240714 :: Ken Moss Removed via NG Deprecation recommendation
    CoreModule,
    QuickSearchModule,
    SharedModule,
    AdjustmentsModule,
    MatButtonModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PrimaryInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
